/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ProLaborLevelDesignationWithNameResponse } from '../api-models';
// @ts-ignore
import { UpdateProLaborLevelDesignation } from '../api-models';
// @ts-ignore
import { ViewProLaborLevelDesignation } from '../api-models';
/**
 * ProLaborLevelDesignationApi - axios parameter creator
 * @export
 */
export const ProLaborLevelDesignationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Handles HTTP GET requests to retrieve a list of ProLabor level designations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proLaborLevelDesignationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ProLaborLevelDesignation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pro Designations with associated Labor Level Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proLaborLevelDesignationProDesignationsWithNameGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ProLaborLevelDesignation/pro-designations-with-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * proLaborLevelDesignationId: The ID of the Pro Labor Level Designation to retrieve.
         * @summary Updates the LaborLevel of a ProLaborLevelDesignation
         * @param {number} proLaborLevelDesignationId 
         * @param {UpdateProLaborLevelDesignation} [updateProLaborLevelDesignation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proLaborLevelDesignationProLaborLevelDesignationIdPut: async (proLaborLevelDesignationId: number, updateProLaborLevelDesignation?: UpdateProLaborLevelDesignation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proLaborLevelDesignationId' is not null or undefined
            assertParamExists('proLaborLevelDesignationProLaborLevelDesignationIdPut', 'proLaborLevelDesignationId', proLaborLevelDesignationId)
            const localVarPath = `/ProLaborLevelDesignation/{proLaborLevelDesignationId}`
                .replace(`{${"proLaborLevelDesignationId"}}`, encodeURIComponent(String(proLaborLevelDesignationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProLaborLevelDesignation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProLaborLevelDesignationApi - functional programming interface
 * @export
 */
export const ProLaborLevelDesignationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProLaborLevelDesignationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Handles HTTP GET requests to retrieve a list of ProLabor level designations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proLaborLevelDesignationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewProLaborLevelDesignation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proLaborLevelDesignationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Pro Designations with associated Labor Level Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proLaborLevelDesignationProDesignationsWithNameGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProLaborLevelDesignationWithNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proLaborLevelDesignationProDesignationsWithNameGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * proLaborLevelDesignationId: The ID of the Pro Labor Level Designation to retrieve.
         * @summary Updates the LaborLevel of a ProLaborLevelDesignation
         * @param {number} proLaborLevelDesignationId 
         * @param {UpdateProLaborLevelDesignation} [updateProLaborLevelDesignation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proLaborLevelDesignationProLaborLevelDesignationIdPut(proLaborLevelDesignationId: number, updateProLaborLevelDesignation?: UpdateProLaborLevelDesignation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewProLaborLevelDesignation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proLaborLevelDesignationProLaborLevelDesignationIdPut(proLaborLevelDesignationId, updateProLaborLevelDesignation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProLaborLevelDesignationApi - factory interface
 * @export
 */
export const ProLaborLevelDesignationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProLaborLevelDesignationApiFp(configuration)
    return {
        /**
         * 
         * @summary Handles HTTP GET requests to retrieve a list of ProLabor level designations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proLaborLevelDesignationGet(options?: AxiosRequestConfig): AxiosPromise<Array<ViewProLaborLevelDesignation>> {
            return localVarFp.proLaborLevelDesignationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pro Designations with associated Labor Level Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proLaborLevelDesignationProDesignationsWithNameGet(options?: AxiosRequestConfig): AxiosPromise<ProLaborLevelDesignationWithNameResponse> {
            return localVarFp.proLaborLevelDesignationProDesignationsWithNameGet(options).then((request) => request(axios, basePath));
        },
        /**
         * proLaborLevelDesignationId: The ID of the Pro Labor Level Designation to retrieve.
         * @summary Updates the LaborLevel of a ProLaborLevelDesignation
         * @param {ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proLaborLevelDesignationProLaborLevelDesignationIdPut(requestParameters: ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<ViewProLaborLevelDesignation> {
            return localVarFp.proLaborLevelDesignationProLaborLevelDesignationIdPut(requestParameters.proLaborLevelDesignationId, requestParameters.updateProLaborLevelDesignation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for proLaborLevelDesignationProLaborLevelDesignationIdPut operation in ProLaborLevelDesignationApi.
 * @export
 * @interface ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPutRequest
 */
export interface ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPut
     */
    readonly proLaborLevelDesignationId: number

    /**
     * 
     * @type {UpdateProLaborLevelDesignation}
     * @memberof ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPut
     */
    readonly updateProLaborLevelDesignation?: UpdateProLaborLevelDesignation
}

/**
 * ProLaborLevelDesignationApi - object-oriented interface
 * @export
 * @class ProLaborLevelDesignationApi
 * @extends {BaseAPI}
 */
export class ProLaborLevelDesignationApi extends BaseAPI {
    /**
     * 
     * @summary Handles HTTP GET requests to retrieve a list of ProLabor level designations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLaborLevelDesignationApi
     */
    public proLaborLevelDesignationGet(options?: AxiosRequestConfig) {
        return ProLaborLevelDesignationApiFp(this.configuration).proLaborLevelDesignationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pro Designations with associated Labor Level Name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLaborLevelDesignationApi
     */
    public proLaborLevelDesignationProDesignationsWithNameGet(options?: AxiosRequestConfig) {
        return ProLaborLevelDesignationApiFp(this.configuration).proLaborLevelDesignationProDesignationsWithNameGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * proLaborLevelDesignationId: The ID of the Pro Labor Level Designation to retrieve.
     * @summary Updates the LaborLevel of a ProLaborLevelDesignation
     * @param {ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLaborLevelDesignationApi
     */
    public proLaborLevelDesignationProLaborLevelDesignationIdPut(requestParameters: ProLaborLevelDesignationApiProLaborLevelDesignationProLaborLevelDesignationIdPutRequest, options?: AxiosRequestConfig) {
        return ProLaborLevelDesignationApiFp(this.configuration).proLaborLevelDesignationProLaborLevelDesignationIdPut(requestParameters.proLaborLevelDesignationId, requestParameters.updateProLaborLevelDesignation, options).then((request) => request(this.axios, this.basePath));
    }
}
